import { hasValue } from '../../../internal/utils/valueCheck';
export const columnIsSortable = column => {
  return !(hasValue(column.columnSortable) && column.columnSortable === false);
};